var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaiar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9648 40.6785L30.8999 30.6362L20.9627 20.6869L40.9648 0.642822V40.6785Z",
    fill: "url(#paint0_linear_302_1898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.959961 40.6786L10.9623 30.6696L0.959961 20.6607L0.959961 40.6786Z",
    fill: "url(#paint1_linear_302_1898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9621 40.6785L30.9576 30.6696L0.959961 0.642822L0.959961 20.6607L20.9621 40.6785Z",
    fill: "#1A45C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_1898",
    x1: 30.9638,
    y1: 10.6776,
    x2: 24.7218,
    y2: 16.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A45C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_302_1898",
    x1: 7.20974,
    y1: 30.6696,
    x2: 4.08926,
    y2: 33.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A45C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiar);
export default __webpack_public_path__ + "static/media/Maiar.1bf0e4a6722d242ef6ebc48d17013882.svg";
export { ForwardRef as ReactComponent };